import styled from '@emotion/styled';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { ClickAwayListener, Grow, MenuList, Paper } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import ListItemButton from '@mui/material/ListItemButton';
import Popper from '@mui/material/Popper';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import useCustomTags from '../../../hooks/useCustomTags';
import { getUserModules } from '../../../services/api-service';
import { isSubAdmin } from '../../../services/auth-service';
import { NewAdminPages, newAuthPages, newAuthSubAdminAccess } from '../../../services/page-service';
import { checkRoles } from '../../../utils/util';
import './menu.css';

export const listItems = [
    { name: 'Accounts', status: '', route: '/admin/accounts', menu: 'People' },//people
    { name: 'Users Profile', status: '', route: '/admin/userProfile', menu: 'People' },//people
    { name: 'Sub Users', status: '', route: '/admin/subUsers', menu: 'People' },//people
    { name: 'Plans', status: '', route: '/admin/plans', menu: 'People' },//people
    { name: 'Agents', status: '', route: '/admin/agent', menu: 'People' },//people
    { name: 'Groups', status: '', route: '/admin/groups', menu: 'People' },//people
    { name: 'IVR Flows', status: '', route: '/admin/ivr', menu: 'Configurations' }, //conf
    // { name: 'IVR Skill Split Selection', status: '', route: '/admin/ivr-skills-split', menu: 'Configurations' }, //conf
    { name: 'Volume Routing', status: '', route: '/admin/volume-based-routing', menu: 'Configurations' }, //conf
    { name: 'Custom Tags', status: '', route: '/admin/customTags', menu: 'Configurations' }, //conf
    // { name: 'Pre & Post Message', status: '', route: '/admin/addCallWork', menu: 'Configurations' },//conf
    { name: 'Manage Numbers', status: '', route: '/admin/manageNumbers', menu: 'Configurations' },//conf
    { name: 'URL Mappings', status: '', route: '/admin/urlMappings', menu: 'Configurations' },//conf
    { name: 'Locations', status: '', route: '/admin/locations', menu: 'Configurations' },//conf
    { name: 'Skills', status: '', route: '/admin/skills', menu: 'Configurations' },//conf
    { name: 'Pause Reasons', status: '', route: '/admin/pauseReasons', menu: 'Configurations' },//conf
    { name: 'Dispositions', status: '', route: '/admin/dispositions', menu: 'Configurations' },//conf
    { name: 'Mappings', status: '', route: '/admin/Mappings', menu: 'Configurations' },//conf
    { name: 'SIP Location', status: '', route: '/admin/siplocation', menu: 'Configurations' },//conf
    { name: 'Music File', status: '', route: '/admin/music', menu: 'Configurations' },//conf
    { name: 'Offer and Language Configuration', status: '', route: '/admin/offer-language-configuration', menu: 'Configurations' },//conf
    { name: 'SIP Number', status: '', route: '/admin/sipnumber', menu: 'Configurations' },//conf
    { name: 'Holidays', status: '', route: '/admin/holidays', menu: 'Configurations' },//conf
    { name: 'DID Addition', status: '', route: '/admin/didAddition', menu: 'Configurations' },//conf
    { name: 'Bulk Update', status: '', route: '/admin/bulkUpdate', menu: 'Configurations' },//conf
    { name: 'Bulk Operation Status', status: '', route: '/admin/bulkOperationStatus', menu: 'Configurations' },//conf
    { name: 'Report Status', status: '', route: '/admin/reportStatusAdmin', menu: 'Configurations' },//conf
    { name: 'CXI Senders', status: '', route: '/admin/baSenders', menu: 'Configurations' },//conf
    { name: 'CXI Templates', status: '', route: '/admin/baTemplates', menu: 'Configurations' },//conf
    { name: 'CXI Rate Cards', status: '', route: '/admin/rateCards', menu: 'Configurations' },//conf
    { name: 'CXI Rate Transactions', status: '', route: '/admin/rateTrans', menu: 'Configurations' },//conf

    //{ name: 'Templates', status: '', route: '/admin/EmailTemplate', menu: 'Configurations' },//conf
    // { name: 'DNC Regulations', status: '', route: '/admin/dnc', menu: 'Configurations' },//conf

    { name: 'Integrations', status: '', route: '/admin/integrations', menu: 'Settings' }, //settt
    { name: 'Manage Settings', status: '', route: '/admin/settings', menu: 'Adminstration' },//settt
    { name: 'Manage Widgets', status: '', route: '/admin/manageWidgets', menu: 'Adminstration' },//Adminstaration
    { name: 'Admin settings', status: '', route: '/admin/AdminSettings', menu: 'Settings' },//settt
    { name: 'Agent settings', status: '', route: '/admin/AgentSettings', menu: 'Settings' },//settt
    { name: 'API Configuration', status: '', route: '/admin/widgetdetails', menu: 'Adminstration' },//Adminstaration
    { name: 'Feature', status: '', route: '/admin/features', menu: 'Adminstration' },//Adminstaration
    { name: 'Cluster Accounts', status: '', route: '/admin/clusterAccounts', menu: 'Adminstration' },//Adminstaration
    { name: 'Dialer configuration', status: '', route: '/admin/dialers', menu: 'Adminstration' },//Adminstaration

];

function AdminMenu(props) {

    const open = Boolean(props.anchorEl);
    const navigate = useNavigate();
    const { enableCustomTags } = useCustomTags();
    // const location = useLocation();
    // const [currentRoute, setCurrentRoute] = useState('');


    // useEffect(() => {
    //     if (location.pathname) {
    //         setCurrentRoute(location.pathname);
    //     }
    // }, [location]);

    const [superAdmin, setSuperAdmin] = useState(false);
    useEffect(() => {
        try {
            getUserModules().then(resp => {
                let roles = resp.Data.roles;
                let isFound = false;
                if (roles != null && roles.length !== 0) {
                    roles.forEach((role) => {
                        if (role.name === 'ROLE_ADMIN') {
                            isFound = true;
                            return
                        }
                    });
                }
                setSuperAdmin(isFound);
            })
        } catch (error) {
            console.error("Error checking custom tags", error);
        }
    }, [])



    const handleClose = () => {
        props.handleClose();
    };

    const [expanded, setExpanded] = useState('People');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };


    const Accordion = styled((props) => (
        <MuiAccordion disableGutters elevation={0}  {...props} />
    ))(({ theme }) => ({
        border: '0px solid white',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '& .MuiAccordionSummary-root': {
            minHeight: '35px',
            maxHeight: '35px'
        }
    }));


    const AccordionDetails = styled((props) => (
        <MuiAccordionDetails  {...props} />
    ))(({ theme }) => ({
        paddingTop: 0,
        paddingBottom: '10px'
    }));

    const navigateTo = (menuName) => {
        // if (currentRoute.includes('users') || currentRoute.includes('agent')) {
        //     navigate('/admin/');
        //     navigate(-1);
        // }
        if (menuName === 'Accounts' || menuName === 'Sub Users' || menuName === 'Plans' || menuName === 'Agents' || menuName === 'Admin settings' || menuName === 'Users Profile') {
            navigate('/admin/');
            navigate(-1);
        }
    }

    const AccordionMenuItems = (props) => {
        let activeStyle = {
            color: "#3D8BF8",
        };
        let menu = props.menu;

        let filteredMenuValues = listItems.filter((component, index) => {
            switch (component.name) {
                case "Dispositions":
                    return (newAuthPages(NewAdminPages.DISPOSITIONS_PAGE) || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'Full') || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'Edit') || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'View'));
                case "URL Mappings":
                    return (checkRoles('ROLE_ADMIN') && superAdmin);
                case "IVR Flows":
                    return (newAuthPages(NewAdminPages.IVR_FLOWS) || newAuthSubAdminAccess(NewAdminPages.IVR_FLOWS, 'Full') || newAuthSubAdminAccess(NewAdminPages.IVR_FLOWS, 'Edit') || newAuthSubAdminAccess(NewAdminPages.IVR_FLOWS, 'View'));
                // case "IVR Skill Split Selection":
                //     return (newAuthPages(NewAdminPages.IVR_SKILL_SPLIT_SELECTION) || newAuthSubAdminAccess(NewAdminPages.IVR_SKILL_SPLIT_SELECTION, 'Full') || newAuthSubAdminAccess(NewAdminPages.IVR_SKILL_SPLIT_SELECTION, 'Edit') || newAuthSubAdminAccess(NewAdminPages.IVR_SKILL_SPLIT_SELECTION, 'View'));
                case "Volume Routing":
                    return (newAuthPages(NewAdminPages.IVR_SKILL_SPLIT_SELECTION) || newAuthSubAdminAccess(NewAdminPages.IVR_SKILL_SPLIT_SELECTION, 'Full') || newAuthSubAdminAccess(NewAdminPages.IVR_SKILL_SPLIT_SELECTION, 'Edit') || newAuthSubAdminAccess(NewAdminPages.IVR_SKILL_SPLIT_SELECTION, 'View'));
                case "Custom Tags":
                    return (newAuthPages(NewAdminPages.CUSTOM_TAGS) || newAuthSubAdminAccess(NewAdminPages.CUSTOM_TAGS, 'Full') || newAuthSubAdminAccess(NewAdminPages.CUSTOM_TAGS, 'Edit') || newAuthSubAdminAccess(NewAdminPages.CUSTOM_TAGS, 'View')) && enableCustomTags && !isSubAdmin();
                case "Pause Reasons":
                    return (newAuthPages(NewAdminPages.PAUSE_REASONS) || newAuthSubAdminAccess(NewAdminPages.PAUSE_REASONS, 'Full') || newAuthSubAdminAccess(NewAdminPages.PAUSE_REASONS, 'Edit') || newAuthSubAdminAccess(NewAdminPages.PAUSE_REASONS, 'View'));
                case "Skills":
                    return (newAuthPages(NewAdminPages.SKILLS_PAGE) || newAuthSubAdminAccess(NewAdminPages.SKILLS_PAGE, 'Full') || newAuthSubAdminAccess(NewAdminPages.SKILLS_PAGE, 'Edit') || newAuthSubAdminAccess(NewAdminPages.SKILLS_PAGE, 'View'));
                case "Mappings":
                    return (newAuthPages(NewAdminPages.MAPPING) || newAuthSubAdminAccess(NewAdminPages.MAPPING, 'Full') || newAuthSubAdminAccess(NewAdminPages.MAPPING, 'Edit') || newAuthSubAdminAccess(NewAdminPages.MAPPING, 'View'));
                case "Locations":
                    return (newAuthPages(NewAdminPages.LOCATIONS) || newAuthSubAdminAccess(NewAdminPages.LOCATIONS, 'Full') || newAuthSubAdminAccess(NewAdminPages.LOCATIONS, 'Edit') || newAuthSubAdminAccess(NewAdminPages.LOCATIONS, 'View'));
                case "Groups":
                    return ((newAuthPages(NewAdminPages.GROUPS) || newAuthSubAdminAccess(NewAdminPages.GROUPS, 'Full') || newAuthSubAdminAccess(NewAdminPages.GROUPS, 'Edit') || newAuthSubAdminAccess(NewAdminPages.GROUPS, 'View')) && (checkRoles("ROLE_ADMIN") || checkRoles("ROLE_USER")));
                case "Agents":
                    return newAuthPages(NewAdminPages.AGENTS_PAGE) || newAuthSubAdminAccess(NewAdminPages.AGENTS_PAGE, 'View') || newAuthSubAdminAccess(NewAdminPages.AGENTS_PAGE, 'dataUpload') || newAuthSubAdminAccess(NewAdminPages.AGENTS_PAGE, 'Edit') || newAuthSubAdminAccess(NewAdminPages.AGENTS_PAGE, 'Full');
                case "Manage Numbers":
                    return (newAuthPages(NewAdminPages.MANAGE_NUMBERS) || newAuthSubAdminAccess(NewAdminPages.MANAGE_NUMBERS, 'Edit') || newAuthSubAdminAccess(NewAdminPages.MANAGE_NUMBERS, 'View') || newAuthSubAdminAccess(NewAdminPages.MANAGE_NUMBERS, 'Full'));
                case "Accounts":
                    return (checkRoles('ROLE_ADMIN') && superAdmin);
                case "Sub Users":
                    return ((newAuthPages(NewAdminPages.SUB_USERS) || newAuthSubAdminAccess(NewAdminPages.SUB_USERS, 'Full') || newAuthSubAdminAccess(NewAdminPages.SUB_USERS, 'Edit') || newAuthSubAdminAccess(NewAdminPages.SUB_USERS, 'View')) && localStorage.getItem('parentUser') === 'null' && !superAdmin);
                case "Plans":
                    return (checkRoles('ROLE_ADMIN') && superAdmin);
                case "SIP Location":
                    return (newAuthPages(NewAdminPages.SIP_LOCATION) || newAuthSubAdminAccess(NewAdminPages.SIP_LOCATION, 'Full') || newAuthSubAdminAccess(NewAdminPages.SIP_LOCATION, 'Edit') || newAuthSubAdminAccess(NewAdminPages.SIP_LOCATION, 'View'))
                case "Music File":
                    return (newAuthPages(NewAdminPages.MUSIC_FILE) || newAuthSubAdminAccess(NewAdminPages.MUSIC_FILE, 'Full') || newAuthSubAdminAccess(NewAdminPages.MUSIC_FILE, 'Edit') || newAuthSubAdminAccess(NewAdminPages.MUSIC_FILE, 'View'));
                case "Offer and Language Configuration":
                    return (newAuthPages(NewAdminPages.OFFER_LANGUAGE_CONFIGURATION) || newAuthSubAdminAccess(NewAdminPages.OFFER_LANGUAGE_CONFIGURATION, 'Full') || newAuthSubAdminAccess(NewAdminPages.OFFER_LANGUAGE_CONFIGURATION, 'Edit') || newAuthSubAdminAccess(NewAdminPages.OFFER_LANGUAGE_CONFIGURATION, 'View'));
                case "SIP Number":
                    return ((newAuthPages(NewAdminPages.SIP_NUMBER) || newAuthSubAdminAccess(NewAdminPages.SIP_NUMBER, 'Full') || newAuthSubAdminAccess(NewAdminPages.SIP_NUMBER, 'Edit') || newAuthSubAdminAccess(NewAdminPages.SIP_NUMBER, 'View')) && checkRoles("ROLE_ADMIN"));
                // case "Pre & Post Message":
                //     return (newAuthPages(NewAdminPages.PREPOST_PAGE) || newAuthSubAdminAccess(NewAdminPages.PREPOST_PAGE, 'Full') || newAuthSubAdminAccess(NewAdminPages.PREPOST_PAGE, 'Edit') || newAuthSubAdminAccess(NewAdminPages.PREPOST_PAGE, 'View'))
                case "Users Profile":
                    return ((localStorage.getItem('parentUser') === 'null' || localStorage.getItem('parentUser' === null)) && !checkRoles('ROLE_ADMIN'))
                case "Holidays":
                    return (newAuthPages(NewAdminPages.HOLIDAYS) || newAuthSubAdminAccess(NewAdminPages.HOLIDAYS, 'Full') || newAuthSubAdminAccess(NewAdminPages.HOLIDAYS, 'Edit') || newAuthSubAdminAccess(NewAdminPages.HOLIDAYS, 'View'));
                case "DID Addition":
                    return (newAuthPages(NewAdminPages.DID_ADDITION) || newAuthSubAdminAccess(NewAdminPages.DID_ADDITION, 'Full') || newAuthSubAdminAccess(NewAdminPages.DID_ADDITION, 'Edit') || newAuthSubAdminAccess(NewAdminPages.DID_ADDITION, 'View'));
                case "Integrations":
                    return (newAuthPages(NewAdminPages.INTEGRATION_SETTINGS) || newAuthSubAdminAccess(NewAdminPages.INTEGRATION_SETTINGS, 'Full') || newAuthSubAdminAccess(NewAdminPages.INTEGRATION_SETTINGS, 'Edit') || newAuthSubAdminAccess(NewAdminPages.INTEGRATION_SETTINGS, 'View'));
                case "Admin settings":
                    return (newAuthPages(NewAdminPages.ADMIN_SETTTINGS) || newAuthSubAdminAccess(NewAdminPages.ADMIN_SETTTINGS, 'Full') || newAuthSubAdminAccess(NewAdminPages.ADMIN_SETTTINGS, 'Edit') || newAuthSubAdminAccess(NewAdminPages.ADMIN_SETTTINGS, 'View'));
                case "Agent settings":
                    return (newAuthPages(NewAdminPages.AGENT_SETTINGS) || newAuthSubAdminAccess(NewAdminPages.AGENT_SETTINGS, 'Full') || newAuthSubAdminAccess(NewAdminPages.AGENT_SETTINGS, 'Edit') || newAuthSubAdminAccess(NewAdminPages.AGENT_SETTINGS, 'View'));
                case 'Bulk Update':
                    return newAuthPages(NewAdminPages.BULK_UPDATE) || newAuthSubAdminAccess(NewAdminPages.BULK_UPDATE, 'View') || newAuthSubAdminAccess(NewAdminPages.BULK_UPDATE, 'Edit') || newAuthSubAdminAccess(NewAdminPages.BULK_UPDATE, 'Full');
                case 'CXI Templates':
                    return (checkRoles('ROLE_CXI'));
                case 'CXI Senders':
                    return (checkRoles('ROLE_CXI'));
                case 'CXI Rate Cards':
                    return (checkRoles('ROLE_CXI') && checkRoles('ROLE_ADMIN'));
                case 'CXI Rate Transactions':
                    return (checkRoles('ROLE_CXI') && checkRoles('ROLE_ADMIN'));
                case "Feature":
                    return (checkRoles('ROLE_ADMIN') && superAdmin);
                case "API Configuration":
                    return (checkRoles('ROLE_ADMIN') && superAdmin);
                case "Manage Widgets":
                    return (checkRoles('ROLE_ADMIN') && superAdmin);
                case "Manage Settings":
                    return (checkRoles('ROLE_ADMIN') && superAdmin);
                case "Cluster Accounts":
                    return (checkRoles('ROLE_ADMIN') && superAdmin);
                case "Dialer configuration":
                    return (checkRoles('ROLE_ADMIN') && superAdmin);   
                default: return true
            }
        })


        let confList = filteredMenuValues.filter(item => item.menu === props.menu)

        const AccordionSummary = styled((props) => (
            <MuiAccordionSummary
                expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.7rem' }} />}
                {...props}
            />
        ))(({ theme }) => ({
            flexDirection: 'row-reverse',
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                transform: 'rotate(90deg)',
                // color: '#3D8BF8'
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
                transform: 'rotate(90deg)',
                color: '#212121'
            },
            '& .MuiAccordionSummary-content': {

                padding: '0px',
                margin: '0px',
                marginLeft: theme.spacing(1),

            },
        }));
        return (
            <Accordion expanded={expanded === menu} onChange={handleChange(menu)} >
                <AccordionSummary
                    aria-label={"Expand" + menu}
                    aria-controls={menu + "-content"}
                    id={menu + "-header"}
                >
                    <Typography sx={{
                        fontWeight: 500,
                        fontSize: '12px',
                        paddingBottom: '0px',
                        // color: expanded === menu ? "#3D8BF8" : '#212121'
                    }}>{menu}</Typography>
                </AccordionSummary>
                <AccordionDetails className='admin-menu-list'>
                    {confList.map((item, index) => (
                        <div key={item.name} onClick={() => { localStorage.removeItem("ps"); navigateTo(item.name) }}>
                            <NavLink to={item.route} key={item.name + index}
                                onClick={(event) => handleClose(event)} style={({ isActive }) =>
                                    isActive ? activeStyle : undefined
                                }>
                                <ListItemButton key={item.name} sx={{ height: '30px' }}>
                                    {item.name}
                                </ListItemButton>
                            </NavLink>
                        </div>
                    ))}
                </AccordionDetails>
            </Accordion>
        )
    }

    return (
        <Popper
            open={open}
            anchorEl={props.anchorEl}
            role={undefined}
            placement="right"
            transition
        >
            {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{
                        transformOrigin:
                            placement === 'bottom-start' ? 'left right' : 'left bottom',
                    }}
                >
                    <Paper
                        sx={{
                            marginLeft: '8px', borderRadius: '8px',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.06)',
                            border: '1px solid #E6E5E6',
                            maxHeight: '70vh !important',
                            overflowY: 'auto',
                        }}
                    // onMouseLeave={handleClose}
                    >
                        <ClickAwayListener onClickAway={handleClose}>
                            <MenuList
                                id="adminMenu"
                                aria-labelledby="adminModule"
                            >
                                {listItems.map((item, index) => (

                                    !item.menu && <ListItemButton key={item.name} className='admin-menu-list'>
                                        <NavLink to={item.route} onClick={(event) => handleClose(event)}>
                                            {item.name}
                                        </NavLink>
                                    </ListItemButton>


                                ))}
                                <AccordionMenuItems menu='People' />
                                <AccordionMenuItems menu='Configurations' />
                                <AccordionMenuItems menu='Settings' />
                                {checkRoles("ROLE_ADMIN") && <AccordionMenuItems menu='Adminstration' />}
                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>
    );
}


export default AdminMenu;
